import React from 'react'
import { Box, Typography } from "@mui/material";
import backgroundPicture from '../../../images/wildlings_walkout.png'

const NowWePlay = () => {
  return (
      <Box
        sx={{
          display: { xs: "block", md: "none" },
          height: {xs: '200px', sm: '400px', md: '550px', lg: '650px'},
          // eslint-disable-next-line 
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          backgroundImage: `linear-gradient( 45deg, rgba(255, 0, 0, 0.31) 0%, rgba(255, 0, 0, 0.31) 100%), url(${backgroundPicture})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          color: 'white',
          fontSize: "30px",
          p: 3,
          textAlign: "center",
          fontStyle: "italic",
        }}
      >
        <Typography component="p" 
          sx={{ 
            fontSize: "inherit", 
            fontWeight: 800,
            fontFamily: 'Playfair Display',
            border: "1px dotted white",
            padding: 2,
            backgroundColor: 'transparent',
          }}>
            "NOW WE PLAY"
        </Typography>
      </Box>
  )
}

export default NowWePlay